import { useCallback, useEffect, useMemo, useState } from 'react';
import { i18n } from './i18n';

export const useLanguage = () => {
   const [languageState, setLanguageState] = useState(i18n.language);

   useEffect(() => {
      const handleLanguageChange = newLang => {
         setLanguageState(newLang);
      };

      const unsubscribe = i18n.subscribe(handleLanguageChange);
      return () => unsubscribe();
   }, []);

   const setLanguage = useCallback(lang => i18n.setLanguage(lang), []);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   const t = useCallback((path, variables) => i18n.t(path, variables), [languageState]);

   return useMemo(
      () => ({
         language: languageState,
         setLanguage,
         t,
      }),
      [languageState, setLanguage, t],
   );
};
